import { widgetFilterSchema } from '../../common/schema'
import { okOrThrow } from '../../common/http'
import { homerunnerApiBaseUrl } from '../../hr'
import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

export const specsParamsSchema = widgetFilterSchema.extend({
  feed_id: z.number().int().describe('Filter by feed ID'),
  platform: z.string().nullish().describe('Filter by platform UUID'),
  property: z.string().describe('Filter by property slug'),
}).describe('Data filter options for bed & bath')

export type SpecsFilter = z.infer<typeof specsParamsSchema>

export type PropertySpecs = {
  id: number
  uuid: string
  platform_id: number
  source: string
  bedroom_count: number
  bathroom_count: string
  bed_count: number
  base_guest_count: number
  maximum_guest_count: number
  area_size?: number | null
  area_size_unit?: string | null
}

export async function fetchSpecs(filter: SpecsFilter) {
  const url = new URL(`${homerunnerApiBaseUrl()}/public-api/v1/property-details`)
  Object.entries(filter).forEach(([key, value]) => {
    if (value !== undefined && value !== null) url.searchParams.append(key, String(value))
  })
  const res = await fetch(url.toString())
  await okOrThrow(res, 'Failed to fetch property bed & bath')
  const data = await res.json()

  return {
    ...data,
  } as {
    status: 'ok' | 'error'
    result: PropertySpecs
    status_code: number
  }
}

export function useFetchSpecs(filter: SpecsFilter) {
  return useQuery({
    queryKey: ['specs', filter],
    queryFn: async () => {
      const data = await fetchSpecs(filter)
      return data.result
    },
  })
}
